export default "__VITE_ASSET__Cn6t3d5N__"